import getApiUrl from './apiUrl';
import { getSuiteToken } from './ssoAuth';

/**
 * Wrapper around fetch for backend API calls.
 * - Resolves relative paths against the backend base URL.
 * - Attaches the Astra Suite token as X-Suite-Token so the backend can enforce
 *   SSO (when REQUIRE_SSO is on in production). Harmless when absent.
 */
export default function apiFetch(path, options = {}) {
  const base = getApiUrl();
  const url = /^https?:\/\//i.test(path) ? path : `${base}${path}`;
  const token = getSuiteToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers['X-Suite-Token'] = token;
  return fetch(url, { ...options, headers });
}
